export function initEksekusiGardu() {
    $('.btn-report-fix').on('click', function() {
        $('#formEksekusi')[0].reset();
        $('#exec_id_inspeksi').val($(this).data('id')).trigger('change');
        $('#modalEksekusi').modal('show');
    });

    $('.btn-add-eksekusi').on('click', function() {
        $('#formEksekusi')[0].reset();
        $('#exec_id_inspeksi').val('').trigger('change');
        $('#modalEksekusi').modal('show');
    });

    $('#exec_id_inspeksi').on('change', function() {
        if ($(this).val() === '') {
            $('#manualEntryFields').removeClass('d-none');
        } else {
            $('#manualEntryFields').addClass('d-none');
        }
    });

    $('#formEksekusi').on('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const btn = $('#btnSubmitExec');
        btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm me-1"></span> Menyimpan...');
        
        const formData = new FormData(this);
        $.ajax({
            url: $(this).attr('action'),
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(res) {
                if (res.status === 'success') {
                    Swal.fire('Berhasil', res.message, 'success').then(() => location.reload());
                }
            },
            error: function(err) {
                btn.prop('disabled', false).text('Simpan Penyelesaian');
                Swal.fire('Error', err.responseJSON?.message || 'Gagal menyimpan laporan', 'error');
            }
        });
    });
}
